import React from "react";
import { connect } from "react-redux";
import ModalInvitar from "./modalInvitarMovil.cmpt";
import ModalGestionar from "./modalGestionarMovil.cmpt";
import Modal from "../generalcomponets/modal-mobile";

const mapState = (state) => {
	return {
		listaFamiliares: state.af.listaFamiliares,
		listaPolizas: state.af.listaPolizas,
		sinPolizas: state.af.sinPolizas,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		editarFamiliar: (oFamiliar) => {
			dispatch({ "type": "AF_EDITAR_FAMILIAR", "familiar": oFamiliar});
			dispatch({ "type": "AF_EDITAR_PASO", "paso": 0});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Invitados extends React.Component {

	state = {
		isModalOpened: false,
		modalGestionar: false,
		modalPolizas: false,
	}

	componentWillReceiveProps = () => {
		if(this.props.sinPolizas) {
			this.setState({ modalPolizas: true });
		}
	}

	seleccionaFamiliar = (_item) => {
		let oFamiliar = Object.assign({}, _item);
		this.props.editarFamiliar(oFamiliar);
		this.setState({ modalGestionar: true });
		
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_EDITAR_FAMILIAR", "dispositivo": this.props.dispositivo });
	}

	sinPolizas = () => {
		this.setState({ modalPolizas: false });
	}

	openModalParent = () => {
		this.setState((state) => {
			return {
				isModalOpened: !state.isModalOpened
			}
		});
	}

	closeModalFromChild = () => {
		this.setState({ modalPolizas: false });
	}

	capital_letter = (str) => {
    str = str.split(" ");
    for(let i = 0; i < str.length; i++) {
      str[i] = str[i][0].toUpperCase();
    }
    return str.join("");
  }

	render() {
		return (
			<div className="cards-wrap mt-50">
				<div className="row">
					<div className="col-xs-12">
						<div className="row">
							{ this.props.listaFamiliares.length == 0 &&
								<div className="sin-invitaciones">
									<img width="100%" height="190" src={ require("../img/acceso-compartido.png") } />
									<span className="title-access">Aún no has invitado a nadie</span>
									<span className="text-access">
										Las personas que designes como invitados podrán visualizar tus pólizas de autos y reportar siniestros a través de la aplicación Soy Cliente GNP.
									</span>
									{/* { this.props.listaPolizas.length > 0 && */}
										<button type="button" onClick={this.openModalParent}>Continuar</button>
									{/* } */}
								</div>
							}

							{ this.props.listaFamiliares.map((item, i) =>
								<div key={i} className="col-xs-12 col-md-4">
									<div onClick={this.seleccionaFamiliar.bind(this, item)} className="gestion-btns">
										<div className="row">
											<div className="col-xs-2">
												<div className="circle-name">{this.capital_letter("Nombre completo")}</div>
											</div>
											<div className="col-xs-8 invitado-info">
												<p className="name-access">{item.nombre.length > 10 ? item.nombre.substring(0, 10) + "..." : item.nombre}</p>
												{ item.pendiente == true &&
													<p><small className="text-status">Invitación aceptada</small></p>
												}
												{ item.pendiente == false && item.polizas.length != 0 &&
													<p><small className="text-status">Pendiente de aceptar</small></p>
												}
												{ item.pendiente == false && item.polizas.length == 0 &&
													<p><small className="text-status">Sin pólizas compartidas</small></p>
												}
											</div>
											<div className="col-xs-2 mini-text-gestion">
												<small className="text-status">{`${item.polizas.length} pólizas`}</small>
											</div>
										</div>
									</div>
								</div>
							)}

							{ this.props.listaFamiliares.length != 0 &&
							// <div className="container">
								// <div className="row">
									<div className="col-xs-12 col-md-4">
										<button style={{width: '100%'}} className="add-guest" type="button" onClick={this.openModalParent}>
											{/* <div className="invitado-info" style={{"maxWidth":"initial"}}> */}
												<div className="row">
													<div className="col-xs-10 bor-bottom">
														<span className="name-access">Agregar nuevo invitado</span>
													</div>
													<div className="col-xs-2 bor-bottom">
														<img src={require("../img/add_mini.svg")} />
													</div>
												</div>
											{/* </div> */}
										</button>
									</div>
								// </div>
							// </div>
								
							}

							{ this.state.modalPolizas &&
								<Modal closeModalFromChild={this.closeModalFromChild}>
									<div className='text-center mt-20'>
										<i><img src={require('../img/warning-new-style.svg')}/></i>
									</div>
									<div className='row'>
										<div className='col-xs-12 mb-20'>
											<div className='text-access'>
												No cuentas con pólizas para realizar invitaciones.
											</div>
											<div className='text-center aceptar-cancelar-btn mt-20'>
												<a onClick={this.sinPolizas.bind(this)} className='orange-movil'>Aceptar</a>
											</div>
										</div>
									</div>
								</Modal>
							}
							{this.state.isModalOpened ?
								<ModalInvitar openModalParent={this.openModalParent} />
							: null}
							{this.state.modalGestionar ?
								<ModalGestionar modalOpen={this.state.modalGestionar} />
							: null}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Invitados);



// WEBPACK FOOTER //
// ./src/acceso-familiar/invitados-movil.cmpt.js